import { defineStore } from 'pinia';

export const useAlertStore = defineStore('alert', {
  state: () => ({
    type: null,
    message: null
  }),
  actions: {
    success(message) {
      this.type = 'alert-success';
      this.message = message;
      setTimeout(() => {
        this.type = null;
        this.message = null;
      }, 5000);
    },
    error(message) {
      this.type = 'alert-danger';
      this.message = message;
      setTimeout(() => {
        this.type = null;
        this.message = null;
      }, 5000);
    },
    clear() {
      this.type = null;
      this.message = null;
    }
  }
});
